import { COLUMN_SIZE } from 'components/common/DataGridDevEx/DataGrid.constants';

export const generateColumns = (isBinTracked) => {
    return [
        {
            dataField: 'LotSerial',
            caption: 'Lot number',
            minWidth: COLUMN_SIZE.sm1,
            width: COLUMN_SIZE.md0,
            fixed: true,
            allowSorting: true,
            allowEditing: false,
        },
        ...(isBinTracked
            ? [
                {
                    dataField: 'Bin',
                    caption: 'Bin',
                    minWidth: COLUMN_SIZE.sm1,
                    width: COLUMN_SIZE.sm0,
                    fixed: true,
                    allowSorting: true,
                    allowEditing: false,
                },
                {
                    dataField: 'BinType',
                    caption: 'Bin type',
                    minWidth: COLUMN_SIZE.sm1,
                    width: COLUMN_SIZE.sm0,
                    fixed: true,
                    allowSorting: true,
                    allowEditing: false,
                },
            ]
            : []),
        {
            dataField: 'Expiry',
            caption: 'Expiry',
            minWidth: COLUMN_SIZE.sm1,
            width: COLUMN_SIZE.sm0,
            fixed: true,
            allowSorting: true,
            allowEditing: true,
        },
        {
            dataField: 'Quantity',
            caption: 'Quantity',
            minWidth: COLUMN_SIZE.sm1,
            width: COLUMN_SIZE.sm0,
            fixed: true,
            allowSorting: true,
            allowEditing: true,
        },
        {
            dataField: 'Price',
            caption: 'Price',
            minWidth: COLUMN_SIZE.sm1,
            width: COLUMN_SIZE.sm0,
            fixed: true,
            allowSorting: true,
            allowEditing: true,
        },
        {
            dataField: 'Description',
            caption: 'Description',
            minWidth: COLUMN_SIZE.sm1,
            width: COLUMN_SIZE.sm0,
            fixed: true,
            allowSorting: true,
            allowEditing: true,
        },
    ];
};

export const LOT_FOCUS_TIMEOUT = 300;
